import { render, staticRenderFns } from "./RiskScoreDetailsTable.vue?vue&type=template&id=b3c39b88&scoped=true"
import script from "./RiskScoreDetailsTable.vue?vue&type=script&lang=js"
export * from "./RiskScoreDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreDetailsTable.vue?vue&type=style&index=0&id=b3c39b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c39b88",
  null
  
)

export default component.exports